import { cn } from '@/lib/utils';
import type { Priority } from '../types/models';

const PRIORITY_CLASSES: Record<Priority, string> = {
  Critical: 'bg-rose-500/15 text-rose-600 dark:text-rose-300',
  High: 'bg-amber-500/15 text-amber-700 dark:text-amber-300',
  Medium: 'bg-blue-500/15 text-blue-600 dark:text-blue-300',
  Low: 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-300',
};

export default function PriorityChip({ priority }: { priority: Priority }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold leading-none',
        PRIORITY_CLASSES[priority] ?? PRIORITY_CLASSES.Medium,
      )}
    >
      {priority}
    </span>
  );
}
